const initBanner = {
  banners: [],
  isFormLoading: false,
};

export const bannerReducer = (state = initBanner, action: any) => {
  if (action.type === "SET_BANNER") {
    return {
      ...state,
      banners: action.value,
    };
  }
  if (action.type === "ADD_BANNER") {
    return { ...state, banners: [action.value, ...state.banners] };
  }
  if (action.type === "UPDATE_BANNER") {
    return {
      ...state,
      banners: state.banners.map((banner: any) =>
        banner.id === action.value.id ? action.value : banner
      ),
    };
  }
  if (action.type === "DELETE_BANNER") {
    return {
      ...state,
      banners: state.banners.filter(({ id }: any) => id !== action.id),
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
